import ServiceGraphQL from 'src/service/gql-service';
import { updateBill } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const UpdateBill = (variables) => {
  const params = {
    query: updateBill.QUERY,
    variables
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
